var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPondooCleanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.9219C0 22.3508 22.3508 0 49.9219 0H234.078C261.649 0 284 22.3508 284 49.9219V234.078C284 261.649 261.649 284 234.078 284H49.9219C22.3508 284 0 261.649 0 234.078V49.9219Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.996 156.282C169.088 156.282 191.05 134.013 191.05 106.541C191.05 79.0701 169.088 56.8003 141.996 56.8003C115.066 56.8003 93.2044 78.8044 92.9438 106.049L92.9414 106.541V218.944C92.9414 223.504 96.6381 227.2 101.198 227.2V227.2C105.758 227.2 109.455 223.504 109.455 218.944V143.763C118.114 151.552 129.51 156.282 141.996 156.282ZM141.996 139.538C124.024 139.538 109.455 124.765 109.455 106.541C109.455 88.3178 124.024 73.5448 141.996 73.5448C159.968 73.5448 174.537 88.3178 174.537 106.541C174.537 124.765 159.968 139.538 141.996 139.538Z",
    fill: "#F6EDE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPondooCleanLogo);
export default __webpack_public_path__ + "static/media/Pondoo_clean_logo.6db1890ec862263d9c45d48e2f7abd8c.svg";
export { ForwardRef as ReactComponent };